export enum SanHeader {
  CLOSE = "search_close",
  OPEN = "search_open",
  X = "search_x",
  CANCEL = "search_cancel"
}
